import { useMemo } from "react";
import { Grid } from "semantic-ui-react";
import { useGetCountries } from "../../../api/static-data";
import { DropDown, InputText, TitleView } from "../../../components";
import { FACILITY_OWNERSHIP, FACILITY_TYPES } from "../../../config/constants";
import { validateCharacterLength } from "../../../utils/utils";

const FacilityInfoSimulation = ({
  register,
  errors,
  country,
  setFacilityValue,
  setCountry,
  defaultFacilityType,
  setDefaultType,
  defaultFacilityOwnerShip,
  setDefaultOwnerShip,
  originalFacilityData,
  isFacilitySimulation,
  isViewMode = false
}: any) => {
  const {
    data: countriesData,
    isSuccess: isCountriesDataSuccess,
    isLoading: isCountriesDataLoading
  } = useGetCountries();

  const countries = useMemo(() => {
    if (isCountriesDataSuccess) {
      return countriesData?.map((c: any) => ({
        key: c.id,
        text: c.country,
        value: c.id
      }));
    }
  }, [countriesData, isCountriesDataSuccess]);

  return (
    <>
      <TitleView title="Facility Info" CustomTitleViewMain="facilityRegisterTitle" />
      <Grid>
        <Grid.Row divided>
          {isFacilitySimulation ? (
            <Grid.Column computer={8} tablet={8} mobile={8}>
              <Grid>
                <Grid.Column computer={6} tablet={8} mobile={16}>
                  <label className="textLabel">Facility Name</label>
                  <br />
                  <label className="textLabel">{originalFacilityData?.facilityName}</label>
                </Grid.Column>
                <Grid.Column computer={6} tablet={8} mobile={16}>
                  <label className="textLabel">Facility Ownership</label>
                  <br />
                  <label className="textLabel">
                    {
                      FACILITY_OWNERSHIP?.find(
                        (types: any) => originalFacilityData?.facilityOwnership == types?.value
                      )?.text
                    }
                  </label>
                </Grid.Column>
                <Grid.Column computer={6} tablet={8} mobile={16}>
                  <label className="textLabel">Facility Type</label>
                  <br />
                  <label className="textLabel">
                    {
                      FACILITY_TYPES?.find(
                        (types: any) => originalFacilityData?.facilityType == types?.value
                      )?.text
                    }
                  </label>
                </Grid.Column>
                <Grid.Column computer={6} tablet={8} mobile={16}>
                  <label className="textLabel">Address</label>
                  <br />
                  <label className="textLabel">{originalFacilityData?.facilityAddress}</label>
                </Grid.Column>
                <Grid.Column computer={6} tablet={8} mobile={16}>
                  <label className="textLabel">City</label>
                  <br />
                  <label className="textLabel">{originalFacilityData?.facilityCity}</label>
                </Grid.Column>
                <Grid.Column computer={6} tablet={8} mobile={16}>
                  <label className="textLabel">Country</label>
                  <br />
                  <label className="textLabel">
                    {
                      countries?.find(
                        (country: any) => originalFacilityData?.facilityCountry == country?.value
                      )?.text
                    }
                  </label>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          ) : null}
          <Grid.Column computer={isFacilitySimulation ? 8 : 16} tablet={8} mobile={8}>
            <Grid>
              <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                <InputText
                  register={register}
                  errors={errors.facilityName}
                  labelName={"Facility Name*"}
                  placeholder="Name"
                  name="facilityName"
                  required={true}
                  errorMessage={"Please enter facility name"}
                  disabled={isViewMode}
                  validateHandle={(value: string) =>
                    validateCharacterLength(value, 32, "Name cannot exceed 32 characters")
                  }
                />
              </Grid.Column>
              <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                <DropDown
                  labelName={"Facility Ownership*"}
                  placeholder="Ownership"
                  currentData={FACILITY_OWNERSHIP}
                  defaultValue={defaultFacilityOwnerShip}
                  customGridColumn={"customGridColomnType"}
                  handleChangeState={(e: any, { value }: any) => {
                    setDefaultOwnerShip(value);
                  }}
                  disabled={isViewMode}
                />
              </Grid.Column>
              <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                <DropDown
                  labelName={"Facility Type*"}
                  placeholder="Type"
                  currentData={FACILITY_TYPES}
                  defaultValue={defaultFacilityType}
                  customGridColumn={"customGridColomnType"}
                  handleChangeState={(e: any, { value }: any) => {
                    setDefaultType(value);
                  }}
                  disabled={isViewMode}
                />
              </Grid.Column>
              <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                <InputText
                  register={register}
                  errors={errors.facilityAddress}
                  labelName={"Address"}
                  placeholder="Address"
                  name="facilityAddress"
                  required={true}
                  errorMessage={"Please enter facility address"}
                  disabled={isViewMode}
                />
              </Grid.Column>
              <Grid.Column
                computer={8}
                tablet={16}
                mobile={16}
                className="facilityEnergyRegisterTitle"
              >
                <InputText
                  register={register}
                  errors={errors.facilityCity}
                  labelName={"City"}
                  placeholder="City"
                  name="facilityCity"
                  required={true}
                  errorMessage={"Please enter facility city"}
                  disabled={isViewMode}
                />
              </Grid.Column>
              <Grid.Column
                computer={8}
                tablet={16}
                mobile={16}
                className="facilityEnergyRegisterTitle"
              >
                <DropDown
                  labelName="Country*"
                  placeholder="Select country"
                  defaultValue={country}
                  currentData={countries}
                  handleChangeState={(e: any, { value }: any) => {
                    setFacilityValue("facilityCountry", value);
                    setCountry(value);
                  }}
                  loading={isCountriesDataLoading}
                  search
                  key={"country"}
                  disabled={isViewMode}
                />
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default FacilityInfoSimulation;
